import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import UnitDetails from './UnitDetails';

import './unitList.scss';
export function UnitList({
	children,
	className,
	facility,
	phone,
	units = [],
	unitDetailsComponentProps = () => {},
	unitDetailsComponent = UnitDetails,
	isVipUnit,
	showIcons
}) {
	return (
		<div className={classnames(className, 'unit-list', { vip: isVipUnit })}>
			{units.map((unit) => {
				const props = {
					...unitDetailsComponentProps(unit),
					unit,
					facility,
					showIcon: showIcons,
					phone,
					key: unit.id,
				};
				return React.createElement(unitDetailsComponent, props);
			})}
			{children}
		</div>
	);
}

UnitList.propTypes = {
	/** Immutable list of units */
	units: PropTypes.arrayOf(PropTypes.object),
	facility: PropTypes.object.isRequired,
	/** The component to render the unit with */
	unitDetailsComponent: PropTypes.func,
	unitDetailsComponentProps: PropTypes.func,
	className: PropTypes.string,
	children: PropTypes.node,
	phone: PropTypes.object,
	isVipUnit: PropTypes.bool,
	showIcons: PropTypes.bool
};

export default UnitList;
